// extracted by mini-css-extract-plugin
module.exports = {"root":"Auth_root__1sRVu","leftItem":"Auth_leftItem__3atuW","rightItem":"Auth_rightItem__3E1g3","container":"Auth_container__3Qr6g","appName":"Auth_appName__2ZAAe"};